/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState, useRef, useContext } from "react";
import axios from "axios";
import InputField from "components/fields/InputField";
import { Select, Button } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import AutoComplete from "react-select";
import SweetAlert2 from "react-sweetalert2";
import { Tooltip } from "@mui/material";
import { FaAngleLeft } from "react-icons/fa";
import MerchantListModal from "../shared/MerchantListModal";

const initialData: {
  merchant_id: string;
  firstname: string;
  lastname: string;
  business_name: string;
  email: string;
  mobile_dialcode: string;
  mobile: string;
} = {
  merchant_id: "",
  firstname: "",
  lastname: "",
  business_name: "",
  email: "",
  mobile_dialcode: "",
  mobile: "",
};

const CreateAgent = () => {
  const [newAgent, setNewAgent] = useState<any>(initialData);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isCreating, setIsCreating] = useState<boolean>(false);
  const [dialcodeList, setDialcodeList] = useState<any>(null);
  const [swalProps, setSwalProps] = useState<any>({});

  const navigate = useNavigate();
  const userRole = localStorage.getItem("userRole")?.toLowerCase();

  const [isMerchantModalOpen, setIsMerchantModalOpen] = useState<boolean>(false);
  const [selectedMerchant, setSelectedMerchant] = useState<any>(null);

  const dialcodeAutoCompleteRef = useRef(null);
  const [dialcodeAutoCompleteOptions, setDialcodeAutoCompleteOptions] =
    useState<any>(null);

  const handleInputChange = async (event: any) => {
    const { id, value } = event.target;
    if (id === "mobile") {
      const numericValue = value.replace(/[^0-9]/g, "");
      setNewAgent({ ...newAgent, [id]: numericValue });
    } else {
      setNewAgent({ ...newAgent, [id]: value });
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      await fetchCountries();
      setIsLoading(false);
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (dialcodeList !== null) {
      setIsLoading(true);
      let rebuildListArray: any = [];

      Object.entries(dialcodeList).forEach(([key, value]: [any, any]) => {
        let newObj = {
          value: key,
          label: value,
        };
        rebuildListArray.push(newObj);
      });

      setDialcodeAutoCompleteOptions(rebuildListArray);
      setIsLoading(false);
    }
  }, [dialcodeList]);

  const fetchCountries = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_API_URL + `/api/datasource/countries`
      );

      let countries = response?.data;
      let dialcodeList: any = [];
      if (countries.length > 0) {
        countries.forEach((c: any) => {
          if (c.dialcode !== null) {
            if (c.dialcode in dialcodeList) {
              dialcodeList[c.dialcode] =
                dialcodeList[c.dialcode] + ", " + c.country_name;
            } else {
              dialcodeList[c.dialcode] =
                "(+" + c.dialcode + ") " + c.country_name;
            }
          }
        });
      }

      const sortedDialcodeList: any = [];
      Object.keys(dialcodeList)
        .sort()
        .forEach((key: any) => {
          sortedDialcodeList[key] = dialcodeList[key];
        });

      setDialcodeList(sortedDialcodeList);
    } catch (error) {
      console.error("Error fetching countries", error);
    }
  };

  const handleMerchantSelect = (merchantData: any) => {
    setSelectedMerchant(merchantData);
    setNewAgent((prev: any) => ({ ...prev, merchant_id: merchantData.id }));
  };

  const handleClearMerchant = () => {
    setSelectedMerchant(null);
    setNewAgent((prev: any) => ({ ...prev, merchant_id: "" }));
  };

  const handleDialcodeAutoCompleteChange = (item: any) => {
    if (item !== null) {
      setNewAgent({ ...newAgent, mobile_dialcode: item.value });
    } else {
      setNewAgent({ ...newAgent, mobile_dialcode: "" });
    }
  };

  const noDialcodeOptionsMessageRenderer = ({
    inputValue,
  }: {
    inputValue: string;
  }) => {
    return <div className="text-sm">Dialcode not found for "{inputValue}"</div>;
  };

  const isValidEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const isFormValid =
    newAgent !== null
      ? newAgent.firstname &&
        newAgent.lastname &&
        newAgent.email &&
        isValidEmail(newAgent.email) &&
        newAgent.business_name &&
        newAgent.mobile_dialcode &&
        newAgent.mobile &&
        newAgent.merchant_id
      : false;

  const handleSubmit = async () => {
    if (isFormValid) {
      newAgent.username = localStorage.getItem("username");
      newAgent.userRole = userRole;

      if (newAgent.address === "") {
        delete newAgent.address;
      }

      if (newAgent.state === "") {
        delete newAgent.state;
      }

      if (newAgent.postcode === "") {
        delete newAgent.postcode;
      }

      if (newAgent.country === "") {
        delete newAgent.country;
      }

      try {
        setIsCreating(true);
        await axios
          .post(
            process.env.REACT_APP_API_URL +
              `/api/${userRole}/agent/action/create-agent`,
            newAgent
          )
          .then(function (response) {
            if (response && response.data?.status === "ok") {
              setSwalProps({
                show: true,
                icon: "success",
                title: "Success",
                html: "Create agent successfully",
                showConfirmButton: true,
                didClose: () => {
                  setSwalProps({});
                  setIsCreating(false);
                  navigate(
                    `/${userRole}/agents/${response.data?.result?.payload?.subaccount_id}`
                  );
                },
              });
            } else {
              setIsCreating(false);
              setSwalProps({
                show: true,
                icon: "error",
                title: "Oops!",
                html: response.data.message,
                showConfirmButton: true,
                didClose: () => {
                  setSwalProps({});
                  setIsCreating(false);
                },
              });
            }
          })
          .catch(function (error) {
            setIsCreating(false);
            setSwalProps({
              show: true,
              icon: "error",
              title: "Oops!",
              html: error.response.data.message,
              showConfirmButton: true,
              didClose: () => {
                setSwalProps({});
                setIsCreating(false);
              },
            });
          });
      } catch (error: any) {
        setIsCreating(false);
        setSwalProps({
          show: true,
          icon: "error",
          title: "Oops!",
          html: "Something went wrong, please try again later.",
          showConfirmButton: true,
          didClose: () => {
            setSwalProps({});
            setIsCreating(false);
          },
        });
      }
    }
  };

  return (
    <>
      <form>
        <div className="inter mx-auto max-w-5xl space-y-6 rounded-xl bg-white p-12 shadow-lg ring-1 ring-gray-100">
          <div>
            <Button
              type="button"
              onClick={() => navigate(`/${userRole}/agents`)}
              isDisabled={isCreating}
              className="
                mb-1 inline-flex items-center gap-1
                text-sm font-medium text-gray-700
                transition hover:text-gray-700
                disabled:cursor-not-allowed disabled:opacity-40
                dark:text-gray-400 dark:hover:text-white
              "
            >
              <FaAngleLeft className="text-base" />
              <span>Agents</span>
            </Button>
            <h2 className="text-left text-2xl font-bold text-navy-700">
              Create Agent
            </h2>
          </div>

          {/* Section 1: Basic Info */}
          <div className="space-y-4 border-b border-gray-200 pb-8">
            <p className="text-md font-medium tracking-normal text-gray-700">
              Provide the agent's personal and contact information
            </p>

            <div className="grid grid-cols-1 gap-8 gap-y-4 md:grid-cols-2">
              <div>
                <InputField
                  disabled={isCreating}
                  variant="auth"
                  extra="shadow-sm"
                  label="First Name"
                  required={true}
                  placeholder="Enter first name"
                  id="firstname"
                  value={newAgent.firstname}
                  type="text"
                  autoComplete="off"
                  onChange={handleInputChange}
                />
              </div>

              <div>
                <InputField
                  disabled={isCreating}
                  variant="auth"
                  extra="shadow-sm"
                  label="Last Name"
                  required={true}
                  placeholder="Enter last name"
                  id="lastname"
                  value={newAgent.lastname}
                  type="text"
                  autoComplete="off"
                  onChange={handleInputChange}
                />
              </div>

              <div>
                <InputField
                  disabled={isCreating}
                  variant="auth"
                  extra="shadow-sm"
                  label="Business Name"
                  required={true}
                  placeholder="Enter business name"
                  id="business_name"
                  value={newAgent.business_name}
                  type="text"
                  autoComplete="off"
                  onChange={handleInputChange}
                />
              </div>

              <div>
                <InputField
                  disabled={isCreating}
                  variant="auth"
                  extra="shadow-sm"
                  label="Email"
                  required={true}
                  placeholder="Enter email address"
                  id="email"
                  value={newAgent.email}
                  type="email"
                  autoComplete="off"
                  onChange={handleInputChange}
                />
              </div>

              <div>
                <label className="text-sm font-medium text-gray-800">
                  Dialcode <span className="text-red-500">*</span>
                </label>
                <AutoComplete
                  ref={dialcodeAutoCompleteRef}
                  isDisabled={
                    isLoading ||
                    isCreating ||
                    dialcodeAutoCompleteOptions === null ||
                    dialcodeAutoCompleteOptions.length === 0
                  }
                  placeholder={
                    dialcodeAutoCompleteOptions === null
                      ? "Retrieving..."
                      : "Please Select"
                  }
                  options={dialcodeAutoCompleteOptions}
                  classNamePrefix="custom-autocomplete"
                  className="autocomplete-override"
                  menuPortalTarget={document.body}
                  styles={{
                    menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
                  }}
                  onChange={(item: any) =>
                    handleDialcodeAutoCompleteChange(item)
                  }
                  noOptionsMessage={noDialcodeOptionsMessageRenderer}
                  isClearable
                />
              </div>

              <div>
                <InputField
                  disabled={isCreating}
                  variant="auth"
                  extra="shadow-sm"
                  label="Phone"
                  required={true}
                  placeholder="Enter mobile number"
                  id="mobile"
                  value={newAgent.mobile}
                  type="text"
                  autoComplete="off"
                  onChange={handleInputChange}
                />
              </div>
            </div>
          </div>

          {/* Section 2: Merchant & Subaccount */}
          <div className="space-y-4 border-b border-gray-200 pb-8">
            <h3 className="text-md font-medium tracking-normal text-gray-700">
              Assign the merchant for the agent
            </h3>
            <div className="grid grid-cols-1 gap-8 gap-y-4 md:grid-cols-1">
              <div>
                <label className="text-sm font-medium text-gray-800">
                  Merchant <span className="text-red-500">*</span>
                </label>
                <Tooltip
                  title={selectedMerchant ? selectedMerchant.name : "Please Select"}
                  arrow
                  placement="top"
                >
                  <div
                    onClick={() => !isCreating && setIsMerchantModalOpen(true)}
                    className={`relative flex w-full items-center rounded-md pl-4 pr-8 text-sm ${
                      isCreating
                        ? "cursor-not-allowed bg-disabledBg text-gray-700 font-medium py-[11px]"
                        : "cursor-pointer bg-white text-navy-700 hover:bg-gray-50 border border-gray-300 shadow-sm font-medium py-2.5"
                    }`}
                  >
                    <span className="truncate">
                      {selectedMerchant ? selectedMerchant.name : "Please Select"}
                    </span>
                    {selectedMerchant && !isCreating && (
                      <button
                        type="button"
                        onClick={(e) => { e.stopPropagation(); handleClearMerchant(); }}
                        className="absolute right-2 top-1/2 -translate-y-1/2 text-lg font-medium text-gray-400 hover:text-gray-600"
                      >
                        ×
                      </button>
                    )}
                  </div>
                </Tooltip>
              </div>

              {/* <div>
              <label className="mb-1 block text-sm font-medium text-gray-800">
                Subaccounts
              </label>
              <Select
                multiple
                className="w-full rounded-md border border-gray-300 px-3 py-2.5 text-sm tracking-tight shadow-sm placeholder:font-medium"
              >
                <option>Subaccount A</option>
                <option>Subaccount B</option>
                <option>Subaccount C</option>
                <option>Subaccount D</option>
              </Select>
              <p className="mt-1 text-sm text-gray-400">
                Hold Cmd (Mac) or Ctrl (Windows) to select multiple
              </p>
            </div> */}
            </div>
          </div>

          {/* Section 3: Asset, Method, Fee Group */}
          {/* <div className="space-y-4 pb-8">
          <h3 className="text-md font-medium tracking-normal text-gray-700">
            Configure how this agent will handle payouts and fees
          </h3>
          <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
            <div>
              <label className="mb-1 block text-sm font-medium text-gray-800">
                Asset
              </label>
              <Select className="w-full rounded-md border border-gray-300 px-3 py-2.5 text-sm tracking-tight shadow-sm placeholder:font-medium">
                <option disabled selected>
                  Select Asset
                </option>
                <option>USD</option>
                <option>THB</option>
              </Select>
            </div>

            <div>
              <label className="mb-1 block text-sm font-medium text-gray-800">
                Method
              </label>
              <Select className="w-full rounded-md border border-gray-300 px-3 py-2.5 text-sm tracking-tight shadow-sm placeholder:font-medium">
                <option disabled selected>
                  Select Method
                </option>
                <option>Bank Transfer</option>
                <option>Crypto</option>
              </Select>
            </div>

            <div>
              <label className="mb-1 block text-sm font-medium text-gray-800">
                Fee Group
              </label>
              <Select className="w-full rounded-md border border-gray-300 px-3 py-2.5 text-sm tracking-tight shadow-sm placeholder:font-medium">
                <option disabled selected>
                  Select Fee Group
                </option>
                <option>Group A</option>
                <option>Group B</option>
              </Select>
            </div>
          </div>
        </div> */}

          <div className="md:text-right">
            <Button
              onClick={() => navigate(`/${userRole}/agents`)}
              isDisabled={isCreating}
              className="mr-4 rounded-md border border-gray-300 bg-white px-8 py-2 text-sm font-semibold tracking-tight text-gray-700 shadow-sm transition hover:bg-gray-100 hover:text-gray-900 active:bg-gray-200 disabled:cursor-not-allowed disabled:opacity-60 dark:border-white/20 dark:bg-white/10 dark:text-white dark:hover:bg-white/20 md:px-10"
            >
              Back
            </Button>
            <Button
              onClick={() => handleSubmit()}
              isDisabled={!isFormValid || isCreating}
              isLoading={isCreating}
              loadingText="Creating..."
              className="btn-primary relative overflow-hidden rounded-md px-8 py-2.5 font-semibold text-white shadow-md transition-colors duration-300 hover:bg-primary-500 active:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-60 md:px-10"
            >
              <span className="relative z-0 tracking-tight">Create Agent</span>
              <span className="absolute inset-0 z-0 scale-0 rounded-md bg-white/20 opacity-0 transition-all duration-500 group-hover:scale-150 group-hover:opacity-100" />
            </Button>
          </div>
        </div>
      </form>

      {/* Merchant Selection Modal */}
      {isMerchantModalOpen && (
        <MerchantListModal
          isOpen={isMerchantModalOpen}
          onClose={() => setIsMerchantModalOpen(false)}
          onSelect={handleMerchantSelect}
          entityType="AGNT#"
        />
      )}

      <SweetAlert2
        {...swalProps}
        customClass={{
          actions: "custom-swal2-popup-action",
          title: "custom-swal2-popup-title",
          confirmButton:
            "custom-swal2-popup-action custom-swal2-popup-action-confirm",
          cancelButton:
            "custom-swal2-popup-action custom-swal2-popup-action-cancel",
        }}
      ></SweetAlert2>
    </>
  );
};

export default CreateAgent;
